export const PUT_HTTP_ERROR = 'put_http_error';
export const DELETE_HTTP_ERROR = 'delete_http_error';
export const DELETE_ALL_HTTP_ERROR = 'delete_all_http_error';
